import React, { useEffect, useRef } from "react";
import "./Swipe.css";

interface SwipeProps {
  steps: string[];
  activeStep: number;
  onStepClick?: (index: number) => void;
}

const Swipe: React.FC<SwipeProps> = ({ steps, activeStep, onStepClick }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  const hasMoved = useRef(false);

  /* CENTRALIZA STEP ATIVO */

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const activeElement = container.children[activeStep] as HTMLElement;

    if (!activeElement) return;

    activeElement.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  }, [activeStep]);

  /* DRAG START */

  const startDrag = (e: any) => {
    const container = containerRef.current;
    if (!container) return;

    isDragging.current = true;
    hasMoved.current = false;

    startX.current = (e.touches?.[0]?.pageX ?? e.pageX) - container.offsetLeft;

    scrollLeft.current = container.scrollLeft;

    container.style.cursor = "grabbing";
  };

  /* DRAG END */

  const stopDrag = () => {
    const container = containerRef.current;
    if (!container) return;

    isDragging.current = false;

    container.style.cursor = "grab";

    /* evita ghost click pós swipe */

    setTimeout(() => {
      hasMoved.current = false;
    }, 50);
  };

  /* DRAG MOVE */

  const onDrag = (e: any) => {
    const container = containerRef.current;
    if (!container || !isDragging.current) return;

    const x = (e.touches?.[0]?.pageX ?? e.pageX) - container.offsetLeft;

    const walk = x - startX.current;

    if (Math.abs(walk) > 5) {
      hasMoved.current = true;
    }

    container.scrollLeft = scrollLeft.current - walk;
  };

  /* CLICK CONTROLADO */

  const handleClick = (index: number) => {
    if (hasMoved.current) return;

    onStepClick?.(index);
  };

  return (
    <div
      ref={containerRef}
      className="stepperSwipe"
      onMouseDown={startDrag}
      onMouseMove={onDrag}
      onMouseUp={stopDrag}
      onMouseLeave={stopDrag}
      onTouchStart={startDrag}
      onTouchMove={onDrag}
      onTouchEnd={stopDrag}
    >
      {steps.map((step, index) => (
        <button
          key={step}
          className={`stepChip ${index === activeStep ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          {step}
        </button>
      ))}
    </div>
  );
};

export default Swipe;
